import { createFileRoute } from "@tanstack/react-router";
import { BotCreatePage } from "./-bot-create-page";

export const Route = createFileRoute("/_app/bots/new")({
  component: BotCreatePage,
});
